import { type Dispatch, type SetStateAction, createContext } from 'react';

export interface SynchronizedCrosshairContextProps {
  hoveredChartId?: string;
  hoveredTimestamp?: number;
  updateHoverState: (chartId?: string, timestamp?: number) => void;
  disabled: boolean;
  setDisabled: Dispatch<SetStateAction<boolean>>;
}

export const SynchronizedCrosshairContext = createContext<
  SynchronizedCrosshairContextProps | undefined
>(undefined);
